export default function ClientInfoStep({ onNext }) {
  return (
    <>
      <h3>Client Information</h3>

      <input placeholder="Client Name" />
      <input placeholder="Client Address" />
      <input placeholder="Project Contact Name & Email" />

      <button className="btn primary" onClick={onNext}>Next</button>
    </>
  );
}
